// src/StopIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StopIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M10.5752 5.38281C11.6798 5.38281 12.5752 6.27824 12.5752 7.38281V10.3828C12.5752 11.4874 11.6798 12.3828 10.5752 12.3828H7.5752C6.47063 12.3828 5.5752 11.4874 5.5752 10.3828V7.38281C5.5752 6.27824 6.47063 5.38281 7.5752 5.38281H10.5752Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.0752 0.382812C13.7696 0.382812 17.5752 4.18839 17.5752 8.88281C17.57 13.5751 13.7675 17.3777 9.0752 17.3828C4.38077 17.3828 0.575195 13.5772 0.575195 8.88281C0.575195 4.18839 4.38077 0.382812 9.0752 0.382812ZM9.11133 2.15625C5.37012 2.13625 2.31561 5.14177 2.27539 8.88281V9.0293C2.31576 12.7702 5.37022 15.7759 9.11133 15.7559C12.8525 15.7357 15.8749 12.6973 15.875 8.95605C15.875 5.21479 12.8525 2.17646 9.11133 2.15625Z"
        }
      )
    ]
  }
);

export {
  StopIcon
};
